<template>
    <div class="rigth-panel">
        <div class="rigth-panel-hader">
            <div class="rigth-panel-header-title">
                <span>NOMINEES</span>
            </div>
            <div class="rigth-panel-header-option">
                <b-select v-model="statusFilter" @input="filterNominees" size="is-small">
                    <option value="">All Status</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                    <option value="moved_to_participants">Moved to Participants</option>
                </b-select>
                <span @click="closeParticipantsMobile">Close</span>
            </div>
        </div>
        <div class="rigth-panel-body">
            <div class="nominee-item" v-for="(nominee, index) in filteredNominees" :key="index">
                <div class="nominee-item-header">
                    <div class="nominee-item-image">
                        <div class="nominee-index">
                            {{ index + 1 }}
                        </div>
                        <img v-if="nominee.profile_image"
                            :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + nominee.profile_image" />
                        <img v-else :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + session.logo" />
                    </div>
                </div>
                <div class="nominee-item-body">
                    <div class="nominee-item-title">{{ nominee.name }}</div>
                    <div class="nominee-item-details">
                        <div class="nominee-email" v-if="nominee.email">
                            <b-icon icon="email" size="is-small"></b-icon>
                            {{ nominee.email }}
                        </div>
                        <div class="nominee-phone" v-if="nominee.phone">
                            <b-icon icon="phone" size="is-small"></b-icon>
                            {{ nominee.phone }}
                        </div>
                        <div class="nominee-fee" v-if="nominee.nomination_fee > 0">
                            <b-icon icon="cash" size="is-small"></b-icon>
                            {{ nominee.nomination_fee }} RWF
                        </div>
                    </div>
                    <div class="nominee-description" v-if="nominee.description">
                        {{ nominee.description.length > 100 ? nominee.description.substring(0, 100) + '...' :
                            nominee.description }}
                    </div>
                    <div class="nominee-item-option">
                        <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                            <template #trigger>
                                <b-icon icon="dots-vertical"></b-icon>
                            </template>
                            <b-dropdown-item @click="updateNomineeStatus(nominee, 'approved')" aria-role="listitem">
                                Approve
                            </b-dropdown-item>
                            <b-dropdown-item @click="updateNomineeStatus(nominee, 'rejected')" aria-role="listitem">
                                Reject
                            </b-dropdown-item>
                            <b-dropdown-item @click="moveToParticipants(nominee)" aria-role="listitem">
                                Move to Participants
                            </b-dropdown-item>
                            <b-dropdown-item @click="deleteNominee(nominee)" aria-role="listitem">
                                Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="nominee-item-footer">
                    <div class="nominee-item-footer-left">
                        <b-tag :type="getStatusType(nominee.status)">
                            {{ getStatusText(nominee.status) }}
                        </b-tag>
                    </div>
                    <div class="nominee-item-footer-right">
                        <small>{{ formatDate(nominee.created_at) }}</small>
                    </div>
                </div>
            </div>

            <div v-if="filteredNominees.length === 0" class="no-nominees">
                <div class="no-nominees-content">
                    <b-icon icon="account-group" size="is-large"></b-icon>
                    <h4>No nominees found</h4>
                    <p v-if="statusFilter">No nominees with status "{{ statusFilter }}"</p>
                    <p v-else>No nominees in this category yet</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        session: {
            type: Object,
            default: () => ({})
        },
        category: {
            type: Object,
            default: () => ({})
        },
        nominees: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        statusFilter: "",
        filteredNominees: []
    }),
    watch: {
        nominees: {
            handler() {
                this.filterNominees();
            },
            immediate: true
        },
        statusFilter() {
            this.filterNominees();
        }
    },
    mounted() { },
    methods: {
        closeParticipantsMobile() {
            this.$emit('close');
        },
        filterNominees() {
            if (!this.statusFilter) {
                this.filteredNominees = this.nominees;
            } else {
                this.filteredNominees = this.nominees.filter(
                    nominee => nominee.status === this.statusFilter
                );
            }
        },
        getStatusType(status) {
            switch (status) {
                case "approved":
                    return "is-success";
                case "rejected":
                    return "is-danger";
                case "moved_to_participants":
                    return "is-info";
                default:
                    return "is-warning";
            }
        },
        getStatusText(status) {
            switch (status) {
                case "moved_to_participants":
                    return "Moved to Participants";
                default:
                    return status.charAt(0).toUpperCase() + status.slice(1);
            }
        },
        getPaymentStatusType(status) {
            switch (status) {
                case "paid":
                    return "is-success";
                case "failed":
                    return "is-danger";
                default:
                    return "is-warning";
            }
        },
        getPaymentStatusText(status) {
            return status.charAt(0).toUpperCase() + status.slice(1);
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return this.moment(dateString).format('MMM DD, YYYY');
        },
        updateNomineeStatus(nominee, status) {
            this.$buefy.dialog.confirm({
                title: "Update Nominee Status",
                message: `Are you sure you want to ${status} this nominee?`,
                confirmText: "Yes",
                type: "is-info",
                hasIcon: true,
                onConfirm: () => {
                    this.$emit("update-nominee-status", {
                        nominee_id: nominee.id,
                        status: status
                    });
                },
            });
        },
        moveToParticipants(nominee) {
            this.$buefy.dialog.confirm({
                title: "Move to Participants",
                message: "Are you sure you want to move this nominee to the participants list?",
                confirmText: "Move",
                type: "is-info",
                hasIcon: true,
                onConfirm: () => {
                    this.$emit("move-to-participants", nominee.id);
                },
            });
        },
        deleteNominee(nominee) {
            this.$buefy.dialog.confirm({
                title: "Delete Nominee",
                message: "Are you sure you want to delete this nominee? This action cannot be undone.",
                confirmText: "Delete",
                type: "is-danger",
                hasIcon: true,
                onConfirm: () => {
                    this.$emit("delete-nominee", nominee.id);
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.rigth-panel {
    height: 100%;
    width: calc(100% - 800px);
    border-left: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @media (max-width: 1184px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 60px;
        right: 0;
        width: 350px;
        opacity: 0;
        pointer-events: none;
    }

    .rigth-panel-hader {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;
        background: #fff;
        position: sticky;
        top: 0;

        .rigth-panel-header-option {
            display: flex;
            align-items: center;
            gap: 10px;

            .control {
                min-width: 120px;
            }

            span {
                display: none;
                margin-left: 10px;
                color: red;
                font-weight: 700;
                cursor: pointer;

                @media (max-width: 1184px) {
                    display: flex;
                }
            }
        }
    }

    .rigth-panel-body {
        height: calc(100% - 60px);
        overflow-y: auto;

        .nominee-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid #ddd;
            background: #fff;
            transition: all 0.3s ease;

            &:hover {
                background: #f9f9f9;
            }

            .nominee-item-header {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 15px;

                .nominee-item-image {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    position: relative;
                    border: 2px solid #eee;

                    .nominee-index {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 20px;
                        height: 20px;
                        background: #9fc953;
                        color: white;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 10px;
                        font-weight: bold;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }

            .nominee-item-body {
                padding: 0px 15px 10px;

                .nominee-item-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 8px;
                }

                .nominee-item-details {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    margin-bottom: 8px;

                    div {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 12px;
                        color: #666;

                        .icon {
                            width: 12px;
                            height: 12px;
                        }

                        &.nominee-fee {
                            color: #9fc953;
                            font-weight: 500;
                        }
                    }
                }

                .nominee-description {
                    font-size: 14px;
                    color: #555;
                    line-height: 1.4;
                    margin-bottom: 10px;
                }

                .nominee-item-option {
                    display: flex;
                    justify-content: flex-end;
                }
            }

            .nominee-item-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 15px;
                background: #f8f9fa;
                border-top: 1px solid #eee;

                .nominee-item-footer-left {
                    display: flex;
                    gap: 8px;
                }

                .nominee-item-footer-right {
                    font-size: 12px;
                    color: #888;
                }
            }
        }

        .no-nominees {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 300px;

            .no-nominees-content {
                text-align: center;
                color: #666;

                .icon {
                    color: #ccc;
                    margin-bottom: 15px;
                }

                h4 {
                    margin: 0 0 10px 0;
                    color: #999;
                }

                p {
                    margin: 0;
                    font-size: 14px;
                }
            }
        }
    }
}

@media (max-width: 1184px) {
    .rigth-panel {
        &.show {
            opacity: 1;
            pointer-events: auto;
        }
    }
}
</style>
